import { useCallback } from 'react';
import { useDeleteFunnelPage, useDuplicateFunnelPage } from '../queries/funnel-page-mutations';
import { useFunnelEditorStore } from '../stores/funnelEditorStore';
import { DRAFT_FUNNEL_PAGE_ID } from '../constants/funnels.constants';

export function useFunnelPageActions(storeId: number | undefined) {
    const deleteFunnelPage = useDeleteFunnelPage(storeId ?? 0);
    const duplicateFunnelPage = useDuplicateFunnelPage(storeId ?? 0);
    const clearDraft = useFunnelEditorStore(s => s.clearDraft);

    const handleDeletePage = useCallback(
        (pageId: number) => {
            if (pageId === DRAFT_FUNNEL_PAGE_ID) {
                clearDraft();
                return;
            }
            if (!storeId) return;
            deleteFunnelPage.mutate(pageId);
        },
        [storeId, deleteFunnelPage, clearDraft]
    );

    const handleDuplicatePage = useCallback(
        (pageId: number) => {
            if (!storeId) return;
            if (pageId === DRAFT_FUNNEL_PAGE_ID) return;
            duplicateFunnelPage.mutate(pageId);
        },
        [storeId, duplicateFunnelPage]
    );

    return {
        handleDeletePage,
        handleDuplicatePage,
        isDeleting: deleteFunnelPage.isPending,
        isDuplicating: duplicateFunnelPage.isPending,
    };
}
